module.exports = __webpack_public_path__ + "static/media/login-image.2b58051d.jpg";